var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1334_2376",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1334_2376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60004 15.6127L10.4871 11.7257L14.3741 15.6127L15.6128 14.3741L11.7386 10.4998L15.6256 6.61281L14.3869 5.37414L10.4999 9.26114L6.61287 5.37414L5.37414 6.61281L9.26115 10.4998L5.37414 14.3868L6.60004 15.6127ZM10.4999 19.3845C8.02526 19.3845 5.92585 18.5223 4.20165 16.7981C2.47737 15.0739 1.61523 12.9744 1.61523 10.4998C1.61523 8.02524 2.47737 5.92583 4.20165 4.20159C5.92585 2.47735 8.02526 1.61523 10.4999 1.61523C12.9745 1.61523 15.0739 2.47735 16.7981 4.20159C18.5223 5.92583 19.3845 8.02524 19.3845 10.4998C19.3845 12.9744 18.5223 15.0739 16.7981 16.7981C15.0739 18.5223 12.9745 19.3845 10.4999 19.3845Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleClose);
export default __webpack_public_path__ + "static/media/circle_close.7546e304362fcf5df407e776dbef3be3.svg";
export { ForwardRef as ReactComponent };